import axios from 'axios'
import router from '@/router/index'
import { Alert } from 'vue-m-dialog'
import i18n from '@/i18n'
import { remove } from '@/util/localStorage'

axios.defaults.timeout = 1000000

axios.defaults.crossDomain = true

axios.interceptors.request.use(
  config => {
    if (localStorage.token) {
      config.headers.Authorization = localStorage.token
    }
    // console.log(config)
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

axios.interceptors.response.use(
  response => {
    if (response.headers.authorization) {
      localStorage.token = response.headers.authorization
      localStorage.refreshTime = new Date().getTime()
    }
    return response
  },
  err => {
    console.log(err)
    if (err.response.status === 401) {
      if (localStorage.refreshTime - new Date().getTime() < 30 * 60 * 1000) {
        console.log(err)
        Alert.alert(i18n.t('Auth.forceLogout'))
      } else {
        console.log(err)
        Alert.alert(i18n.t('Auth.loginExpired'))
      }
      router.push({
        name: 'login'
      })
      remove()
      return Promise.reject(err)
    }
    if (err.response.status === 500) {
      Alert.alert(i18n.t('Auth.networkError'))
    }
    console.log(err)
    return Promise.reject(err)
  }
)
export default axios
